const prefix = "studioos_v1_";
export const LOCAL_STORAGE_CONFIG = {
  TOKENS: {
    JWT_TOKEN: prefix + "jwt_token",
  },
};
